import Layout from "@/components/Layout";
import ContactForm from "@/components/ContactForm";

// Converted from contact.php by scripts/convert-php-pages.mjs.
export default function PageContact() {
  return (
    <Layout route="/contact">
      <>
<section style={{ paddingTop: "28px" }}>
<img src="/assets/img/contact-dr-parveen.jpg" className="d-block w-100" alt="..." />
</section>
<div className="location-area" style={{ paddingTop: "70px", textAlign: "center" }}>
<div className="container">
<div className="row location-wrap">
<div className="col-sm-6 col-lg-4">
<div className="location-item">
<i className="icofont-location-pin"></i>
<h3>Location</h3>
<p> Artemis hospital sector 51 gurgaon</p>
</div>
</div>
<div className="col-sm-6 col-lg-4">
<div className="location-item">
<i className="icofont-ui-message"></i>
<h3>Email</h3>
<ul>
<li>info@chestsurgeryindia.com</li>
</ul>
</div>
</div>
<div className="col-sm-6 offset-sm-3 offset-lg-0 col-lg-4">
<div className="location-item">
<i className="icofont-ui-call"></i>
<h3>Phone</h3>
<ul>
<li>+91 9540210956</li>
</ul>
</div>
</div>
</div>
</div>
<p style={{ marginTop: "20px" }}>
    Dr. Parveen Yadav, a renowned Minimal Invasive and Robotic Thoracic Onco Surgeon, leads the expert team at Chest Surgery India. Dr Yadav specializes in cutting-edge thoracic surgery techniques and prioritizes advanced, patient-centred care. The hospital, with state-of-the-art facilities, ensures optimal comfort and outcomes. For appointments or inquiries, contact Chest Surgery India. Trust Dr. Yadav's expertise and exceptional care for your thoracic surgical needs. Your health is our priority.
</p>
</div>
<section className="drop-area pt-100">
<div className="container-fluid">
<div className="row">
<div className="col-lg-7 p-0">
<div className="drop-item drop-img">
<div className="drop-left">
<h1>Drop your message for any info or question.</h1>

<ContactForm />
</div>
</div>
</div>
<div className="col-lg-5 p-0">
<div className="speciality-item speciality-right speciality-right-two speciality-right-three">
<img src="/assets/img/home-two/8.jpg" alt="Contact" />
<div className="speciality-emergency">
<div className="speciality-icon">
<i className="icofont-ui-call"></i>
</div>
<h3>Call for Appointments</h3>
<p>+91 9540210956</p>
</div>
</div>
</div>
</div>
</div>
</section>
<iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3508.576277895369!2d77.0686159!3d28.432039699999997!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390d194a61e8c58b%3A0xf70cfe5b97dcfb08!2sDr.%20Parveen%20Yadav%2C%20Chest%20Surgery%20India!5e0!3m2!1sen!2sin!4v1666405079449!5m2!1sen!2sin" width="100%" height="400" style={{ border: "0" }} allowFullScreen={true} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
      </>
    </Layout>
  );
}
